import React, { useState, useEffect } from 'react';
import pb from '../lib/pocketbase';
import RealisationsHero from '../components/realisations/RealisationsHero/RealisationsHero';
import ProjectCard from '../components/realisations/ProjectCard/ProjectCard';
import Button from '../components/common/Button/Button';
import styles from './Realisations.module.css';
import ActionCTA from '../components/common/ActionCTA/ActionCTA';

function Realisations() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const fetchProjects = async () => {
      try {
        const records = await pb.collection('projects').getFullList({
          sort: '-created',
          signal: controller.signal,
        });
        setProjects(records);
      } catch (err) {
        if (!err.isAbort) {
          setError('Impossible de charger les projets.');
          console.error(err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();

    return () => {
      controller.abort();
    };
  }, []);

  return (
    <>
      <RealisationsHero
        title="Nos Réalisations d'Exception"
        subtitle="Découvrez l'étendue de notre savoir-faire à travers nos projets. Chaque réalisation est une histoire, un rêve devenu réalité."
        backgroundImage="/images/terrasse1.jpg" // Make sure this image exists
      >
        <Button to="/contact" variant="primary">Commencez Votre Projet</Button>
      </RealisationsHero>
      <section className="section">
        <div className="container">
          <div className={styles.introSection}>
            <div className={styles.introContent}>
              <div className={styles.introText}>
                <span className={styles.eyebrow}>Notre Portfolio</span>
                <h2 className={styles.title}>La Qualité et le Savoir-Faire en Images</h2>
                <div className={styles.divider}></div>
                <p className={styles.description}>
                  Chez Maison Quinard, chaque réalisation est la preuve de notre engagement envers l'excellence. Nous combinons des techniques de construction bois éprouvées avec une attention méticuleuse aux détails pour livrer des projets qui dépassent les attentes.
                </p>
                <div className={styles.highlightNotice}>
                  <p>Parcourez nos créations pour trouver l'inspiration pour votre futur projet de vie.</p>
                </div>
              </div>

              <div className={styles.introImageWrapper}>
                <div className={styles.imageCard}>
                  <img src="/images/maison2.jpg" alt="Maison en ossature bois réalisée par Maison Quinard" className={styles.mainImage} />
                  <div className={styles.projectCounter}>
                    <span className={styles.countNumber}>{projects.length}+</span>
                    <span className={styles.countText}>Projets Réalisés</span>
                  </div>
                </div>
                <div className={styles.imageDecoration}></div>
              </div>
            </div>
          </div>


          <div className={styles.projectsGrid}>
            {loading && <p>Chargement des projets...</p>}
            {error && <p className={styles.error}>{error}</p>}
            {!loading && !error && projects.map((project) => {
              const imageUrl = project.cover_image ? pb.files.getURL(project, project.cover_image, { 'thumb': '400x400' }) : '/images/placeholder.png';
              return (
                <ProjectCard
                  key={project.id}
                  title={project.title}
                  description={project.description.replace(/<[^>]+>/g, '').substring(0, 100) + '...'}
                  imageSrc={imageUrl}
                  detailsLink={`/realisations/${project.slug}`}
                />
              );
            })}
          </div>

          <ActionCTA />
        </div>
      </section>
    </>
  );
}

export default Realisations;
